import { jsxs, jsx } from 'react/jsx-runtime';
import { flexRender } from '@tanstack/react-table';
import { styled } from '@mui/material/styles';

const StickyHeader = styled('tr')({
    position: 'sticky',
    top: 0,
    zIndex: 1,
});
const StyledHeaderCell = styled('th')(({ theme }) => ({
    height: 30,
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: 'left',
    backgroundColor: theme.palette.N95.main,
    fontFamily: theme.typography.subtitle2.fontFamily,
    fontSize: theme.typography.subtitle2.fontSize,
    fontWeight: theme.typography.subtitle2.fontWeight,
    letterSpacing: theme.typography.subtitle2.letterSpacing,
    textTransform: theme.typography.subtitle2.textTransform,
    color: theme.palette.N30.main,
}));
/**
 * A row at the top of the data grid that contains the column headers
 */
const ColumnHeaderGroup = ({ headerGroup, isDnDEnabled, }) => (jsxs(StickyHeader, { children: [isDnDEnabled ? jsx(StyledHeaderCell, {}, "drag-handles") : null, headerGroup.headers.map(header => (jsx(StyledHeaderCell, { children: flexRender(header.column.columnDef.header, header.getContext()) }, header.id)))] }, headerGroup.id));

export { ColumnHeaderGroup as default };
//# sourceMappingURL=ColumnHeaderGroup.js.map
